// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * MenuVisibilityChecklist — estilos compartidos por el personalizador de menú
 * del usuario y el panel de plataforma.
 *
 * Solo variables del design system (dark + light), nunca hex fijos.
 */

.mvc-root {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.mvc-group {
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg-card);
  overflow: hidden;
}

.mvc-group-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: var(--slate-200);
  border-bottom: 1px solid var(--border);
}

.mvc-group-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: 0 0 auto;
}

.mvc-group-title {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary);
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.mvc-group-count {
  font-size: 0.72rem;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.mvc-group-toggle {
  margin-left: auto;
  background: transparent;
  border: 1px solid var(--border);
  color: var(--accent);
  border-radius: 6px;
  padding: 3px 10px;
  font-size: 0.72rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.mvc-group-toggle:hover {
  background: rgba(var(--accent-rgb), 0.12);
  border-color: var(--accent);
}

.mvc-items {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 2px 14px;
  padding: 10px 12px;
}

.mvc-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 6px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.84rem;
  color: var(--text-primary);
  transition: background 0.12s ease;
}

.mvc-item:hover {
  background: var(--slate-100);
}

.mvc-item input[type='checkbox'] {
  width: 15px;
  height: 15px;
  accent-color: var(--accent);
  cursor: pointer;
  flex: 0 0 auto;
}

.mvc-item-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mvc-item--locked {
  cursor: not-allowed;
  color: var(--text-muted);
}

.mvc-item--locked:hover {
  background: transparent;
}

.mvc-item--locked input[type='checkbox'] {
  cursor: not-allowed;
}

.mvc-item--readonly {
  cursor: default;
}

.mvc-item-lock {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.66rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--text-muted);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 1px 7px;
  white-space: nowrap;
}

.mvc-item-lock svg {
  width: 11px;
  height: 11px;
}

.mvc-hint {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.8rem;
  color: var(--text-secondary);
  background: var(--slate-200);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 9px 11px;
}
`, "",{"version":3,"sources":["webpack://./src/components/MenuVisibilityChecklist.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":["/**\r\n * MenuVisibilityChecklist — estilos compartidos por el personalizador de menú\r\n * del usuario y el panel de plataforma.\r\n *\r\n * Solo variables del design system (dark + light), nunca hex fijos.\r\n */\r\n\r\n.mvc-root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n\r\n.mvc-group {\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  background: var(--bg-card);\r\n  overflow: hidden;\r\n}\r\n\r\n.mvc-group-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 12px;\r\n  background: var(--slate-200);\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.mvc-group-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.mvc-group-title {\r\n  margin: 0;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  letter-spacing: 0.02em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.mvc-group-count {\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.mvc-group-toggle {\r\n  margin-left: auto;\r\n  background: transparent;\r\n  border: 1px solid var(--border);\r\n  color: var(--accent);\r\n  border-radius: 6px;\r\n  padding: 3px 10px;\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.mvc-group-toggle:hover {\r\n  background: rgba(var(--accent-rgb), 0.12);\r\n  border-color: var(--accent);\r\n}\r\n\r\n.mvc-items {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\r\n  gap: 2px 14px;\r\n  padding: 10px 12px;\r\n}\r\n\r\n.mvc-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 5px 6px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 0.84rem;\r\n  color: var(--text-primary);\r\n  transition: background 0.12s ease;\r\n}\r\n\r\n.mvc-item:hover {\r\n  background: var(--slate-100);\r\n}\r\n\r\n.mvc-item input[type='checkbox'] {\r\n  width: 15px;\r\n  height: 15px;\r\n  accent-color: var(--accent);\r\n  cursor: pointer;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.mvc-item-label {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.mvc-item--locked {\r\n  cursor: not-allowed;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.mvc-item--locked:hover {\r\n  background: transparent;\r\n}\r\n\r\n.mvc-item--locked input[type='checkbox'] {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.mvc-item--readonly {\r\n  cursor: default;\r\n}\r\n\r\n.mvc-item-lock {\r\n  margin-left: auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 0.66rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  color: var(--text-muted);\r\n  border: 1px solid var(--border);\r\n  border-radius: 999px;\r\n  padding: 1px 7px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.mvc-item-lock svg {\r\n  width: 11px;\r\n  height: 11px;\r\n}\r\n\r\n.mvc-hint {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n  font-size: 0.8rem;\r\n  color: var(--text-secondary);\r\n  background: var(--slate-200);\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  padding: 9px 11px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
